import {ChangeDetectorRef, Component} from '@angular/core';
import {combineLatest, Observable} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {ApiFragment} from '../../../entities/api-fragment.entity';
import {GetFieldPipe} from '../../../pipes/get-field.pipe';
import {BaseColumnComponent} from '../../../services/base-column-component';
import {CellOptions} from '../../../entities/cell-options/cell-options.entity';

@Component({
    standalone: false,
    selector: 'digihaven-text-cell',
    templateUrl: './text-cell.component.html',
    styleUrls: ['./text-cell.component.scss']
})
export class TextCellComponent<O extends CellOptions = CellOptions> extends BaseColumnComponent<ApiFragment, O> {
    value$!: Observable<string>;

    constructor(private fieldPipe: GetFieldPipe, protected cd: ChangeDetectorRef) {
        super(cd);

        this.value$ = combineLatest([this.data$, this.fieldDefinition$, this.defaultValue$]).pipe(
            switchMap(([fragment, fieldDef, defaultValue]) => {
                return this.fieldPipe.transform(fragment, fieldDef, defaultValue, false);
            })
        );
    }
}
